import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycabhireforweddingindelhi() {



  const cardData =
  {
    keyword: 'Luxury Cab Hire for Weddings in Delhi',
    heading: 'Aaryan Travels: Luxury Cab Hire for Weddings in Delhi',
    headingDescription: 'Aaryan Travels offers elegant and well-coordinated Luxury Cab Hire for Weddings in Delhi, ensuring grand and stylish transportation for your special day. Whether you need a premium sedan for the groom’s entry, a high-end SUV for family travel, or a fleet of luxury cars for VIP guests, our collection—including Mercedes, BMW, Audi, and Innova Crysta—delivers both comfort and class. We also provide decorated bridal cars with professional chauffeurs to match your wedding theme. From South Delhi to Gurgaon, Noida to Aerocity, Aaryan Travels guarantees punctual, prestigious, and hassle-free wedding cab arrangements across Delhi NCR.',

    top: 'Top Places to Visit in Delhi with Aaryan Travels',

"topPlaces": [
  {
    "title": "Red Fort",
    "description": "Red Fort, built by Mughal Emperor Shah Jahan in 1648, is one of India’s most celebrated UNESCO World Heritage Sites. Its massive red sandstone walls, grand halls, and intricate carvings reflect Mughal architectural brilliance. The evening light-and-sound show narrates India’s history in a captivating style. Every Independence Day, the Prime Minister addresses the nation from its ramparts. Red Fort is Delhi’s proud symbol of heritage and strength."
  },
  {
    "title": "Qutub Minar",
    "description": "Standing at 73 meters, Qutub Minar is the world’s tallest brick minaret and a UNESCO World Heritage Site. Built in the 12th century, it features Indo-Islamic carvings and verses from the Quran etched on its sandstone surface. The surrounding Qutub Complex includes ancient ruins and the Iron Pillar, known for its rust-free longevity. Qutub Minar is Delhi’s towering marvel of history and engineering."
  },
  {
    "title": "India Gate",
    "description": "India Gate is a 42-meter high war memorial dedicated to the Indian soldiers who sacrificed their lives during World War I. Located along Rajpath, it is beautifully illuminated at night and surrounded by lush gardens. The Amar Jawan Jyoti flame burns here eternally in honor of martyrs. Families and tourists gather here for evening strolls and ice cream treats. India Gate is Delhi’s heartfelt tribute to bravery."
  },
  {
    "title": "Lotus Temple",
    "description": "Shaped like a blooming lotus, the Lotus Temple is a Bahá’í House of Worship known for its stunning white marble architecture. Open to people of all faiths, it offers a peaceful space for meditation and silence. Surrounded by tranquil ponds and gardens, it attracts visitors from across the globe. Its serene environment inspires reflection and unity. Lotus Temple is Delhi’s beacon of peace and spiritual harmony."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb, built in 1570, is a masterpiece of Mughal architecture and a UNESCO World Heritage Site. Its charbagh-style garden, marble dome, and symmetrical design inspired the construction of the Taj Mahal. The serene pathways and historic ambiance attract photographers and heritage lovers. Humayun’s Tomb is Delhi’s majestic resting place of royalty and elegance."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a modern architectural wonder showcasing Indian culture, spirituality, and craftsmanship. The sprawling complex includes intricately carved sandstone structures, water shows, boat rides, and exhibitions on ancient India. The evening musical fountain show is a major attraction. Its grand scale and serenity leave visitors in awe. Akshardham is Delhi’s divine celebration of art and devotion."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built by Shah Jahan in 1656, is one of India’s largest mosques. It can accommodate over 25,000 worshippers and features three grand gates and two towering minarets. Visitors can climb the minarets for panoramic views of Old Delhi. The bustling market of Chandni Chowk nearby adds cultural charm. Jama Masjid is Delhi’s monumental blend of spirituality and history."
  },
  {
    "title": "Chandni Chowk",
    "description": "Chandni Chowk is Old Delhi’s busiest and most vibrant market, known for its street food, jewelry shops, and fabric stores. From parathas at Paranthe Wali Gali to jalebis and kebabs, it is a paradise for food lovers. Rickshaws, shoppers, and vendors fill every lane with energy. Historic landmarks like Fatehpuri Masjid and Gauri Shankar Temple add to the experience. Chandni Chowk is Delhi’s living tapestry of flavor and tradition."
  },
  {
    "title": "Hauz Khas Village",
    "description": "Hauz Khas Village is a trendy neighborhood blending history and modern nightlife. The 14th-century Hauz Khas Fort overlooks a scenic lake, while surrounding streets are filled with cafes, art boutiques, and designer stores. Youngsters love its vibrant nightlife and artistic ambiance. It’s a perfect mix of heritage and hip culture. Hauz Khas is Delhi’s coolest hangout hub."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is the memorial dedicated to Mahatma Gandhi, located on the banks of the Yamuna River. The black marble platform marks the spot where he was cremated in 1948. The surrounding gardens offer a peaceful space for reflection. Eternal flame burns in his memory. Raj Ghat is Delhi’s sacred homage to the Father of the Nation."
  }
],



"services": [
  {
    "name": "Luxury Cab Hire for Weddings in Delhi",
    "description": "Luxury Cab Hire for Weddings in Delhi provides top-tier chauffeur-driven vehicles designed to make every wedding journey elegant and memorable. From sleek sedans to spacious SUVs, each car is meticulously maintained and decorated upon request. With punctual chauffeurs and flexible rental options, this service ensures the perfect balance of comfort, luxury, and reliability for bridal entries, guest transfers, and wedding events across Delhi."
  },
  {
    "name": "Wedding Chauffeur Cab Delhi",
    "description": "Wedding Chauffeur Cab Delhi offers professional chauffeur-driven cars tailored for wedding occasions. The service features courteous, uniformed drivers trained in event logistics, ensuring smooth coordination, timely arrivals, and a dignified travel experience for couples and guests alike."
  },
  {
    "name": "Premium Wedding Car Delhi",
    "description": "Premium Wedding Car Delhi delivers exclusive luxury vehicles such as Mercedes, BMW, and Audi models for wedding ceremonies and related events. With elegant interiors and customized decor options, the service ensures a royal experience for the bride, groom, and family."
  },
  {
    "name": "Bridal Car Rental Delhi",
    "description": "Bridal Car Rental Delhi specializes in providing beautifully adorned vehicles for bridal entries and post-wedding travel. The service includes personalized decorations, professional chauffeurs, and flexible booking options to ensure a glamorous and comfortable journey."
  },
  {
    "name": "Executive Wedding Transport Delhi",
    "description": "Executive Wedding Transport Delhi offers premium vehicles designed for high-profile wedding events. Ideal for VIP guests, family members, and corporate weddings, the service guarantees style, punctuality, and luxurious comfort throughout the occasion."
  },
  {
    "name": "Classic Wedding Taxi Delhi",
    "description": "Classic Wedding Taxi Delhi brings a vintage charm to weddings with elegant, timeless vehicles that add a touch of sophistication to the event. Whether it’s a classic model or a luxury car, each vehicle is meticulously maintained for a picture-perfect arrival."
  },
  {
    "name": "Wedding Event Cab Delhi",
    "description": "Wedding Event Cab Delhi provides comprehensive cab services for all wedding-related travel needs, including guest pickups, venue transfers, and family transportation. The service is known for its coordination, reliability, and fleet versatility."
  },
  {
    "name": "Luxury Sedan for Wedding Delhi",
    "description": "Luxury Sedan for Wedding Delhi offers stylish sedans equipped with plush interiors and comfort-focused features. These vehicles are ideal for bridal or VIP transportation, ensuring a smooth and elegant experience throughout the celebration."
  },
  {
    "name": "SUV Wedding Cab Delhi",
    "description": "SUV Wedding Cab Delhi provides spacious and luxurious SUVs for wedding events, perfect for families or small groups. The vehicles offer high comfort levels and a stylish presence, suitable for both modern and traditional ceremonies."
  },
  {
    "name": "Affordable Wedding Cab Delhi",
    "description": "Affordable Wedding Cab Delhi combines quality and affordability, offering luxury and comfort at budget-friendly prices. This service caters to families and couples seeking elegance and reliability without exceeding their wedding budgets."
  },
  {
    "name": "Prestige Wedding Car Hire Delhi",
    "description": "Prestige Wedding Car Hire Delhi delivers an exclusive range of luxury vehicles for couples who wish to make a grand entrance. With elegant interiors, professional chauffeurs, and tailored services, it ensures a sophisticated and unforgettable wedding experience."
  },
  {
    "name": "Best Wedding Chauffeur Delhi",
    "description": "Best Wedding Chauffeur Delhi provides expert drivers with years of experience handling wedding events. Courteous, punctual, and well-dressed, these chauffeurs ensure seamless transportation for the bride, groom, and guests throughout the event."
  },
  {
    "name": "Online Wedding Cab Booking Delhi",
    "description": "Online Wedding Cab Booking Delhi offers an easy-to-use platform for reserving luxury wedding cabs. With instant confirmations, customized packages, and flexible options, it allows couples to manage their wedding transport effortlessly."
  },
  {
    "name": "High-End Wedding Transport Delhi",
    "description": "High-End Wedding Transport Delhi provides top-of-the-line vehicles and elite chauffeurs for luxury weddings. Designed for those who demand exclusivity, the service ensures every ride reflects class, sophistication, and grandeur."
  },
  {
    "name": "Wedding Cab Packages Delhi",
    "description": "Wedding Cab Packages Delhi offers customizable transport solutions for entire wedding events, including multiple vehicles for family, friends, and guests. With transparent pricing and coordinated logistics, it simplifies event transportation with elegance and efficiency."
  }
],
"tableData": [
  ["Luxury Cab Hire for Weddings in Delhi", "Wedding Chauffeur Cab Delhi"],
  ["Premium Wedding Car Delhi", "Bridal Car Rental Delhi"],
  ["Executive Wedding Transport Delhi", "Classic Wedding Taxi Delhi"],
  ["Wedding Event Cab Delhi", "Luxury Sedan for Wedding Delhi"],
  ["SUV Wedding Cab Delhi", "Affordable Wedding Cab Delhi"],
  ["Prestige Wedding Car Hire Delhi", "Best Wedding Chauffeur Delhi"],
  ["Online Wedding Cab Booking Delhi", "High-End Wedding Transport Delhi"],
  ["Wedding Cab Packages Delhi", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Cab Hire for Weddings in Delhi",
    "WhyChoosedescription": "Aaryan Travels provides premium luxury cab hire services for weddings in Delhi, ensuring elegance and comfort on your special day."
  },
  {
    "WhyChooseheading": "Premium Fleet of Luxury Vehicles",
    "WhyChoosedescription": "Choose from a wide range of luxury cars perfect for wedding ceremonies, receptions, and related events."
  },
  {
    "WhyChooseheading": "Professional and Courteous Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers offer punctual, respectful, and seamless service tailored for wedding occasions."
  },
  {
    "WhyChooseheading": "Vehicle Decoration Services Available",
    "WhyChoosedescription": "Add a personalized touch with our wedding cab decoration options to enhance your celebration."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for hassle-free budgeting."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings and any last-minute changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Select hourly, daily, or customized plans tailored to your wedding transportation needs."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service on Your Wedding Day",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs, making your wedding events run smoothly without transportation hassles."
  }
]






















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury cab hire for weddings in Delhi?',
    answer: 'Yes, Aaryan Travels provides luxury cab hire services for weddings in Delhi, ensuring a stylish and grand arrival on your big day.',
  },
  {
    question: 'How can I book luxury wedding cabs in Delhi with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Delhi.',
  },
  {
    question: 'What types of luxury vehicles are available for wedding cab hire in Delhi?',
    answer: 'Aaryan Travels offers a premium fleet including Mercedes, BMW, Audi, and luxury SUVs for wedding cab hire in Delhi.',
  },
  {
    question: 'Are the drivers trained for luxury wedding cab hire in Delhi?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and experienced in providing elegant service for weddings.',
  },
  {
    question: 'Can luxury cabs be hired for various wedding events in Delhi?',
    answer: 'Yes, our luxury cabs can be booked for pre-wedding functions, the main ceremony, receptions, and guest transportation in Delhi.',
  },
  {
    question: 'Is the luxury cab hire service for weddings available 24x7 in Delhi?',
    answer: 'Yes, Aaryan Travels offers round-the-clock luxury cab services for weddings to accommodate all schedules and events in Delhi.',
  },
  {
    question: 'Are hygiene and safety protocols followed for wedding cab hires?',
    answer: 'All vehicles are thoroughly sanitized, and drivers follow strict hygiene and safety standards for your peace of mind.',
  },
  {
    question: 'What payment methods are accepted for luxury cab hire for weddings in Delhi?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts for easy and secure payments.',
  },
  {
    question: 'Is customer support available during the luxury wedding cab hire period in Delhi?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your wedding cab hire experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Varun Malhotra',
    feedback: 'Aaryan Travels made our wedding day even more special with their luxurious and perfectly managed cab hire in Delhi.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ayesha Bhatnagar',
    feedback: 'Highly professional and reliable wedding cab hire service in Delhi. Aaryan Travels truly delivered a royal experience.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const luxuryWeddingCabDelhiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Cab Hire for Weddings in Delhi",
  "description": "Aaryan Travels provides luxury cab hire services for weddings in Delhi, including premium chauffeur-driven cars, bridal car rentals, executive wedding transport, and wedding event cabs.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Delhi"
  },
  "serviceType": "Luxury Wedding Cab Hire",
  "keywords": "Luxury Cab Hire for Weddings in Delhi, Wedding Chauffeur Cab Delhi, Premium Wedding Car Delhi, Bridal Car Rental Delhi, Executive Wedding Transport Delhi, Classic Wedding Taxi Delhi, Wedding Event Cab Delhi, Luxury Sedan for Wedding Delhi, SUV Wedding Cab Delhi, Affordable Wedding Cab Delhi, Prestige Wedding Car Hire Delhi, Best Wedding Chauffeur Delhi, Online Wedding Cab Booking Delhi, High-End Wedding Transport Delhi, Wedding Cab Packages Delhi"
};







  return (
    <div>
<Helmet>
  <title>Luxury Cab Hire for Weddings in Delhi | Bridal & Executive Wedding Cars | Aaryan Travels</title>
  <meta
    name="description"
    content="Book luxury cab hire for weddings in Delhi with Aaryan Travels. Premium chauffeur-driven cars, bridal rentals, executive wedding transport, and event cabs."
  />
  <meta
    name="keywords"
    content="Luxury Cab Hire for Weddings in Delhi, Wedding Chauffeur Cab Delhi, Premium Wedding Car Delhi, Bridal Car Rental Delhi, Executive Wedding Transport Delhi, Classic Wedding Taxi Delhi, Wedding Event Cab Delhi, Luxury Sedan for Wedding Delhi, SUV Wedding Cab Delhi, Affordable Wedding Cab Delhi, Prestige Wedding Car Hire Delhi, Best Wedding Chauffeur Delhi, Online Wedding Cab Booking Delhi, High-End Wedding Transport Delhi, Wedding Cab Packages Delhi"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryWeddingCabDelhiSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/98.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycabhireforweddingindelhi;